module.exports = __webpack_public_path__ + "static/mo08-c3f6a50461b09300ef2f8e0e57abb082.png";